import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loadSectionTexts } from '../../utils/contentService';
import { getWeddingCalendarUrl } from '../../utils/calendarUtils';

export default function ConfirmationModal({ onClose, guestName, showCalendar }) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [texts, setTexts] = useState({});

  useEffect(() => {
    const allTexts = loadSectionTexts('confirmation', i18n.language);
    // Extract only modal-related keys
    const modalTexts = {};
    Object.keys(allTexts).forEach((key) => {
      if (key.startsWith('modal.')) {
        modalTexts[key.slice('modal.'.length)] = allTexts[key];
      }
    });
    setTexts(modalTexts);
  }, [i18n.language]);

  const handleAddToCalendar = () => {
    const calendarUrl = getWeddingCalendarUrl(guestName);
    window.open(calendarUrl, '_blank');
    // Redirect to home after opening calendar
    setTimeout(() => {
      navigate('/');
    }, 300);
  };

  const handleClose = () => {
    onClose();
    navigate('/');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={handleClose}></div>
      <div className="relative bg-white p-8 md:p-12 rounded-lg shadow-xl max-w-lg w-full text-center">
        <h3 className="text-2xl md:text-3xl font-serif mb-4">
          {texts.title || ""}
        </h3>
        <p className="text-lg md:text-xl font-serif mb-6">
          {texts.message || ""}
        </p>

        {/* Add to Calendar section - only show if guest confirmed YES */}
        {showCalendar && (
          <div className="mb-6 p-5 bg-blue-50 rounded-xl border-2 border-blue-300">
            <p className="text-base md:text-lg font-serif mb-5 text-gray-800">
              {texts.calendarPrompt || ""}
            </p>
            <button
              onClick={handleAddToCalendar}
              className="w-full h-14 bg-blue1 hover:bg-blue text-white font-serif italic text-lg md:text-xl rounded-xl flex items-center justify-center gap-3 transition-all duration-300 shadow-lg"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
              </svg>
              <span className="font-medium">
                {texts.addToCalendar || ""}
              </span>
            </button>
          </div>
        )}

        <button
          onClick={handleClose}
          className="w-full md:w-auto px-10 py-4 bg-gray-900 hover:bg-black text-white font-serif italic text-lg md:text-xl rounded-xl transition-all duration-300 shadow-md"
        >
          {texts.close || ""}
        </button>
      </div>
    </div>
  );
}
